import * as React from 'react'

const Archive = (props: any) => (
  <svg {...props} viewBox='0 0 16 16' width='16' height='16' fill='#fff' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.0925 2.52427L11.3419 3.40544H4.6643L4.91252 2.52427H11.0925ZM4.18584 5.10369H11.8226L11.5258 4.05515H4.48122L4.18584 5.10369ZM3.10375 5.10369L4.11518 1.5534H11.8888L12.905 5.10369H14.5153L13.0411 0H2.96371L1.486 5.10369H3.10375ZM-6.88744e-08 6.30027L0.823915 10.5437H15.1761L16 6.30027H-6.88744e-08ZM9.22451 8.7233H6.77549C6.4935 8.7233 6.26477 8.49511 6.26477 8.21359C6.26477 7.93208 6.4935 7.70388 6.77549 7.70388H9.22451C9.5065 7.70388 9.73519 7.93208 9.73519 8.21359C9.73519 8.49511 9.5065 8.7233 9.22451 8.7233ZM-6.88744e-08 11.7177L0.901738 16H15.0983L16 11.7177H-6.88744e-08ZM9.22451 14.1408H6.77549C6.4935 14.1408 6.26477 13.9126 6.26477 13.6311C6.26477 13.3496 6.4935 13.1214 6.77549 13.1214H9.22451C9.5065 13.1214 9.73519 13.3496 9.73519 13.6311C9.73519 13.9126 9.5065 14.1408 9.22451 14.1408Z'
      fill='#666'
    />
  </svg>
)
export default Archive



// WEBPACK FOOTER //
// ./src/components/icons/drivers/Archive.tsx